const dateFormatOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
};
export default dateFormatOptions;
